import axios from "axios";
import { Message, Loading,MessageBox  } from "element-ui";
import router from "@/router"
//import config from '/public/config.js'

let loading; //定义loading变量
let loginTip=false

function startLoading() {
  //使用Element loading-start 方法
  loading = Loading.service({
    lock: false,
    text: "加载中...",
    background: "#000"
  });
}
function endLoading() {
  //使用Element loading-close 方法
  loading.close();
}

// 请求拦截  设置统一header
axios.interceptors.request.use(
  config => {
    // 加载
    //startLoading();
    axios.defaults.baseURL=Config.domain
    if (localStorage.getItem("token"))
      config.headers["jwt-token"]=localStorage.getItem("token");
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截  401 token过期处理
axios.interceptors.response.use(
  response => {
    //endLoading();
    if(response.data.msg=='token-err' && !loginTip){
      loginTip=true
      MessageBox.alert("token值无效，请重新登录",{
        confirmButtonText: '确定',
        callback: action => {
          loginTip=false
          //router.push({path:'/login'})
          location.href="/login"
        }
      });
      return Promise.reject("")
    }
    return response;
  },
  error => {
    // 错误提醒
    //endLoading();
    Message.error(error.response.data);

    const { status } = error.response;
    if (status == 401) {
      Message.error("token值无效，请重新登录");
      // 清除token
      localStorage.removeItem("eleToken");
    }

    return Promise.reject(error);
  }
);

// var Http = {
//     post: function(...args) {
//       alert(axios.defaults.url)
//       alert(this.adminAPIURL)
//         return axios.post(...args)
//     },
//     get: function(...args) {
//         return axios.get(...args)
//     }
// }


export default axios;
